<template>
  <div class="entity-select-field d-inline-flex flex-row align-baseline">
    <v-autocomplete
      outlined
      :placeholder="placeholder"
      :label="label"
      :items="items"
      v-model="selectedItem"
      :loading="loading"
      :search-input.sync="searchTerm"
      hide-details="auto"
      :rules="rules"
      clearable
      :hide-no-data="true"
      :return-object="true"
      item-text="text"
      item-value="value.id"
      :filter="() => true"
      :append-icon="null"
    />

    <device-select-dialog ref="deviceSelectDialog" @selected="setSelected" />

    <v-btn
      v-if="showSelectDialogButton"
      icon
      @click="openSelectDialog"
      :title="$t('entitySelect.selectFromList')"
    >
      <v-icon>mdi-form-select</v-icon>
    </v-btn>

    <DeviceCreationDialog
      v-if="renderComponent && showAddDialogButton && $featurePermissions.deviceCRUD"
      @selected="setSelected"
      @dialogClosed="forceRerender"
    />
  </div>
</template>

<script>
import DevicesService from '@/services/DevicesService';
import DeviceSelectDialog from '@/views/devices/DeviceSelectDialog';
import DeviceCreationDialog from '@/views/devices/DeviceCreationDialog';

export default {
  name: 'DeviceSelectField',
  components: { DeviceSelectDialog, DeviceCreationDialog },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    showAddDialogButton: {
      type: Boolean,
      default: false,
    },
    showSelectDialogButton: {
      type: Boolean,
      default: false,
    },

    rules: Array,
  },
  data: () => ({
    selectedItem: null,
    loading: false,
    searchTerm: null,
    timerId: null,
    entities: [],
    renderComponent: true,
  }),


  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.valueComparator(this.value, val)) {
          return;
        }
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
    items() {
      const entitiesForSelection = this.entities.slice();

      if (
        this.selected &&
        !entitiesForSelection.some((entity) => entity.id === this.selected.id)
      ) {
        entitiesForSelection.push(this.selected);
      }
      return entitiesForSelection.map(this.mapToItem);
    },
  },

  methods: {
    mapToItem(device) {
      return {
        text: this.$options.filters.device(device),
        value: device,
      };
    },

    valueComparator(one, two) {
      if (one == null && two == null) {
        return true;
      }
      if (one == null || two == null) {
        return false;
      }
      return one.id === two.id;
    },

    search() {
      if (!this.searchTerm) {
        this.entities = [];
        this.selectedItem = null;
        return;
      }
      if (this.selectedItem && this.searchTerm === this.selectedItem.text) {
        return;
      }

      this.loading = true;
      DevicesService.findDevicesByNameOrIdentification(this.searchTerm)
        .then((result) => {
          this.entities = result.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },

    openSelectDialog() {
      this.$refs.deviceSelectDialog.show();
    },

    setSelected(device) {
      this.selected = device;
      this.setSelectionToAutoComplete(device);
    },

    setSelectionToAutoComplete(selected) {
      const item = this.mapToItem(selected);
      this.selectedItem = item;
      this.searchTerm = item.text;
    },

    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
  },

  watch: {
    selectedItem(item) {
      if (item) {
        this.selected = item.value;
      } else {
        this.selected = null;
      }
    },

    searchTerm() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        this.search();
      }, 500);
    },
  },

  mounted() {
    if (this.selected) {
      this.setSelectionToAutoComplete(this.selected);
    }
  },
};
</script>

<style></style>
